import { RouterModule, Routes } from "@angular/router";
import { LayoutComponent } from "./layout.component";
import { NavComponent } from "./nav/nav.component";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { OrdersModule } from "../orders/orders.module";
import { GamasModule } from "../gamas/gamas.module";
import { ActionsModule } from "../actions/actions.module";
import { DiskModule } from "../disk/disk-space/disk.module";
import { UsersModule } from "../users/users.module";

const routes: Routes = [
  {
    path: 'actions',
    component: LayoutComponent,
    loadChildren: () => ActionsModule
  },
  {
    path: 'disk',
    component: LayoutComponent,
    loadChildren: () => DiskModule
  },
  {
    path: 'gamas',
    component: LayoutComponent,
    loadChildren: () => GamasModule
  },
  {
    path: 'orders',
    component: LayoutComponent,
    loadChildren: () => OrdersModule
  },
  {
    path: 'users',
    component: LayoutComponent,
    loadChildren: () => UsersModule
  },
  {
    path: '**',
    redirectTo: 'orders',
  },
];


@NgModule({
  declarations: [
    NavComponent,
    LayoutComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ]
})
export class LayoutModule { }